import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  SiniestrosService,
  Siniestro,
} from "../../../../../shared/services/siniestrosViales.service";
import Swal from "sweetalert2";
import { Utils } from "../../../../../shared/utils/Utils";
import { TipoSiniestroService } from "../../../../../shared/services/tipo-siniestro.service";
import { NivelSeveridadService } from "../../../../../shared/services/nivel-severidad.service";
import { CondicionesClimaticasService } from "../../../../../shared/services/condiciones-climaticas.service";
import { TiposService } from "../../../../../shared/services/tipos.service";
import { MarcaService } from "../../../../../shared/services/marca.service";
import { ModelosService } from "../../../../../shared/services/modelos.service";
import { VehiclesService } from "../../../../../shared/services/vehicles.service";
import { RelacionService } from "../../../../../shared/services/relacion.service";
import { TipoViaService } from "../../../../../shared/services/tipo-via.service";
import { DataService } from "../../../../../shared/services/municipios.service";
import { EstadoConductorService } from "../../../../../shared/services/estado-conductor.service";
import { ConductorVehiculoService } from "../../../../../shared/services/conductor.service";
import {
  ConductoresSiniestrosVialesService,
  ConductorSiniestro,
} from "../../../../../shared/services/conductores-siniestros-viales.service";
import {
  VehiculoInvolucrado,
  VehiculoInvolucradoService,
} from "../../../../../shared/services/vehiculo-involucrado.service";
import {
  OtrosInvolucrado,
  OtrosInvolucradosService,
} from "../../../../../shared/services/otros-involucrados.service";
import { TipoActorVialService } from "../../../../../shared/services/tipo-actor-vial.service";
import { AdministracionService } from "../../../../../shared/services/administracion.services";
import { Administracion } from "../../../../../shared/model/administracion.model";
import { DigitalesService } from "../../../../../shared/services/digitales.service";

@Component({
  selector: "app-editar-siniestro",
  templateUrl: "./editar-siniestro.component.html",
  styleUrls: ["./editar-siniestro.component.scss"],
})
export class EditarSiniestroComponent implements OnInit {
  formSiniestro!: FormGroup;
  formConductorInvolucrado!: FormGroup;
  formVehiculoInvolucrado!: FormGroup;
  formOtrosInvolucrado!: FormGroup;
  siniestroId!: number;
  hoy: string | undefined;
  propiedadesVehiculo: any[] = [];
  tiposVehiculo: any[] = [];
  marcasVehiculo: any[] = [];
  modelosVehiculo: any[] = [];
  condicionesClimaticas: any[] = [];
  municipios: any[] = [];
  departamentos: any[] = [];
  paises = [{ id: 1, nombre: "Colombia" }];
  vias: any[] = [];
  nivelesSeveridad: any[] = [];
  tiposSiniestro: any[] = [];
  conductoresInvolucrados: ConductorSiniestro[] = [];
  vehiculosInvolucrados: VehiculoInvolucrado[] = [];
  otrosInvolucrados: OtrosInvolucrado[] = [];
  nuevosConductores: ConductorSiniestro[] = [];
  nuevosVehiculos: VehiculoInvolucrado[] = [];
  nuevosOtros: OtrosInvolucrado[] = [];
  mapUrl: string = "";
  pageSizeConductores: number = 5;
  pageConductores: number = 1;
  pageSizeVehiculos: number = 5;
  pageVehiculos: number = 1;
  pageSizeOtros: number = 5;
  pageOtros: number = 1;
  administraciones: Administracion[] = [];
  tiposDocumento = [
    { value: "NIT", label: "NIT" },
    { value: "CC", label: "CEDULA DE CIUDADANIA" },
    { value: "CE", label: "CEDULA DE EXTRANJERIA" },
    { value: "PA", label: "PASAPORTE" },
    { value: "OTRO", label: "OTRO" },
  ];
  categoriasLicencia = [
    { value: "1", label: "MOTOS" },
    { value: "A1", label: "A1" },
    { value: "A2", label: "A2" },
    { value: "B1", label: "B1" },
    { value: "B2", label: "B2" },
    { value: "B3", label: "B3" },
    { value: "C1", label: "C1" },
    { value: "C2", label: "C2" },
    { value: "C3", label: "C3" },
    { value: "TRIPULANTE MOTORISTA", label: "TRIPULANTE MOTORISTA" },
    {
      value: "TRIPULANTE AYUDANTE FLUVIAL",
      label: "TRIPULANTE AYUDANTE FLUVIAL",
    },
    { value: "NO TIENE", label: "NO TIENE" },
  ];
  rolesSiniestro = [
    { value: "1", label: "RESPONSABLE" },
    { value: "2", label: "PRESUNTO RESPONSABLE" },
    { value: "3", label: "NO RESPONSABLE" },
  ];
  estadosConductor: any[] = [];
  conductoresPorPlaca: any[] = [];
  opcionesSiNo = [
    { id: 1, descripcion: "Si" },
    { id: 0, descripcion: "No" },
  ];
  conductorEditandoIndex: number | null = null;
  vehiculoEditandoIndex: number | null = null;
  otroEditandoIndex: number | null = null;

  private mensajesRequeridosInvolucrados: Record<string, string> = {
    placa_involucrado: "Ingresa la placa del vehículo involucrado",
    tipo_vehiculo: "Selecciona el tipo de vehículo",
    propiedad_vehiculo: "Selecciona la propiedad del vehículo",
    fecha_vencimiento: "Ingresa la fecha de vencimiento del SOAT",
    revision_tecnomecanica: "Ingresa la fecha de revisión tecnomecánica",
  };
  tiposActorVial: any;
  documentosGuardados: any;
  archivoSeleccionado!: File | null;
  preview: any = null;
  esImagen = false;

  archivosSeleccionados: File[] = [];
  previews: any[] = [];
  private adminCargada = false;
  private siniestroCargado = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private siniestrosService: SiniestrosService,
    private tipoSiniestroService: TipoSiniestroService,
    private nivelSeveridadService: NivelSeveridadService,
    private condicionesClimaticasService: CondicionesClimaticasService,
    private tiposService: TiposService,
    private marcaService: MarcaService,
    private modelosService: ModelosService,
    private VehiculosService: VehiclesService,
    private relacionService: RelacionService,
    private tipoviaService: TipoViaService,
    private dataService: DataService,
    private digitalesService: DigitalesService,
    private administracionesServices: AdministracionService,
    private tipoActorVialService: TipoActorVialService,
    private estadoConductorService: EstadoConductorService,
    private modalService: NgbModal,
    private conductorVehiculoService: ConductorVehiculoService,
    private conductoresService: ConductoresSiniestrosVialesService,
    private vehiculoInvolucradoService: VehiculoInvolucradoService,
    private otrosInvolucradosService: OtrosInvolucradosService,
  ) {}

  ngOnInit(): void {
    this.siniestroId = Number(this.route.snapshot.paramMap.get("id"));
    this.initForm();
    this.initFormConductorInvolucrado();
    this.initFormVehiculoInvolucrado();
    this.initFormOtrosInvolucrado();
    this.cargarDataAdmin();
    this.cargarSiniestro();
    this.cargarCatalogos();
    this.getDatos();
    this.cargarDatosRelacionados();
    this.cargarTiposActorVial();
    this.hoy = new Date().toISOString().split("T")[0];
  }

  initForm(): void {
    this.formSiniestro = this.fb.group({
      consecutivo: [{ value: "", disabled: true }],
      fecha_siniestro: ["", Validators.required],
      hora_siniestro: ["", Validators.required],
      fecha_reporte: ["", Validators.required],
      hora_reporte: ["", Validators.required],
      tipo_siniestro: ["", Validators.required],
      nivel_severidad: ["", Validators.required],
      lesionados: [0, Validators.required],
      fatalidad: [0, Validators.required],
      numero_victimas: [0, Validators.required],
      descripcion_ocurrido: ["", Validators.required],
      municipio: ["", Validators.required],
      departamento: ["", Validators.required],
      direccion_referencia: ["", Validators.required],
      coordenadas_latitud: [""],
      coordenadas_longitud: [""],
      ruta_trayecto: [""],
      via: [""],
      pais: ["COLOMBIA"],
      condiciones_climaticas: [""],
      placa: ["", Validators.required],
      tipo_vehiculo: ["", Validators.required],
      marca: ["", Validators.required],
      linea: ["", Validators.required],
      modelo: ["", Validators.required],
      propiedad_vehiculo: ["", Validators.required],
    });
  }

  private initFormConductorInvolucrado(): void {
    this.formConductorInvolucrado = this.fb.group({
      nombre: ["", Validators.required],
      tipodocumento: [null],
      n_documento: [null, Validators.required],
      rol_siniestro: [null, Validators.required],
      fecha_nacimiento: ["", Validators.required],
      estado_momento_siniestro: [null, Validators.required],
      categoria: [null, Validators.required],
      n_licencia: [""],
      fecha_expedicion: [""],
      fecha_vencimiento: [""],
      usaba_cinturon: [0],
      mision_laboral: [0],
    });
  }

  private initFormVehiculoInvolucrado(): void {
    this.formVehiculoInvolucrado = this.fb.group({
      placa_involucrado: [null, Validators.required],
      numero_interno: [null],
      tipo_vehiculo: [null, Validators.required],
      propiedad_vehiculo: [null, Validators.required],
      fecha_vencimiento: [null, Validators.required],
      revision_tecnomecanica: [null, Validators.required],
      carga: [0, [Validators.min(0)]],
      descripcion_carga: [null],
      empresa_transportadora: [null],
    });
  }

  private initFormOtrosInvolucrado(): void {
    this.formOtrosInvolucrado = this.fb.group({
      tipo_actor_vial: [null, Validators.required],
      nombre: ["", Validators.required],
      n_documento: [null, Validators.required],
      placa: ["", Validators.required],
      lesiones: [0, [Validators.min(0)]],
      danos: [0, [Validators.min(0)]],
    });
  }

  private cargarCatalogos(): void {
    this.cargarTipoSiniestro();
    this.cargarNivelesSeveridad();
    this.cargarTiposVia();
    this.cargarCondicionesClimaticas();
    this.cargarTiposVehiculo();
    this.cargarMarcasVehiculo();
    this.cargarModelosVehiculo();
    this.cargarRelaciones();
    this.cargarEstadoConductor();
  }

  cargarSiniestro(): void {
    this.siniestrosService.getSiniestroById(this.siniestroId).subscribe({
      next: (data) => {
        this.formSiniestro.patchValue(data);

        this.normalizarMarcaYModelo();
        this.updateMap();

        this.siniestroCargado = true;
        this.intentarCargarDocumentos();
      },
    });
  }

  cargarTiposActorVial(): void {
    this.tipoActorVialService.getTiposActorVialActivos().subscribe({
      next: (tiposActorVial) => (this.tiposActorVial = tiposActorVial),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los tipos de actor vial",
          "error",
        ),
    });
  }

  guardar(): void {
    if (this.formSiniestro.invalid) {
      Swal.fire({
        title: "Atención",
        text: "Complete todos los campos obligatorios",
        icon: "warning",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    const payload: Siniestro = {
      ...this.formSiniestro.getRawValue(),
      id: this.siniestroId,
    };

    this.siniestrosService
      .updateSiniestro(this.siniestroId, payload)
      .subscribe({
        next: () => {
          // ✅ Usamos el id ya existente
          if (this.archivosSeleccionados.length > 0) {
            this.subirDocumentos(this.siniestroId);
          }
          this.guardarRelaciones();
        },
        error: (err) => {
          Swal.fire(
            "Error",
            err.error?.message || "No se pudo actualizar",
            "error",
          );
        },
      });
  }

  private guardarRelaciones(): void {
    const conductoresPayload = this.nuevosConductores.map((c) => ({
      ...c,
      id_siniestro: this.siniestroId,
      estado: c.estado ?? 1,
    }));

    const vehiculosPayload = this.nuevosVehiculos.map((v) => ({
      ...v,
      id_siniestro: this.siniestroId,
      estado: v.estado ?? 1,
    }));

    const otrosPayload: OtrosInvolucrado[] = this.nuevosOtros.map((o) => ({
      id_siniestro: this.siniestroId,
      tipo_actor_vial: o.tipo_actor_vial,
      nombre: o.nombre,
      n_documento: o.n_documento,
      placa: o.placa,
      lesiones: o.lesiones,
      danos: o.danos,
      estado: o.estado ?? 1,
    }));

    const guardarConductores = () => {
      if (conductoresPayload.length === 0) {
        guardarVehiculos();
        return;
      }

      this.conductoresService.createConductor(conductoresPayload).subscribe({
        next: () => guardarVehiculos(),
        error: (err) => {
          Swal.fire(
            "Error",
            err.error?.message || "No se pudieron guardar los conductores",
            "error",
          );
        },
      });
    };

    const guardarVehiculos = () => {
      if (vehiculosPayload.length === 0) {
        guardarOtros();
        return;
      }

      this.vehiculoInvolucradoService
        .createVehiculos(vehiculosPayload)
        .subscribe({
          next: () => guardarOtros(),
          error: (err) => {
            Swal.fire(
              "Error",
              err.error?.message || "No se pudieron guardar los vehículos",
              "error",
            );
          },
        });
    };

    const guardarOtros = () => {
      if (otrosPayload.length === 0) {
        Swal.fire({
          title: "Éxito",
          text: "Siniestro actualizado correctamente",
          icon: "success",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      this.otrosInvolucradosService.create(otrosPayload).subscribe({
        next: () => {
          Swal.fire({
            title: "Éxito",
            text: "Siniestro actualizado correctamente",
            icon: "success",
            confirmButtonText: "Aceptar",
          });
        },
        error: (err) => {
          Swal.fire(
            "Error",
            err.error?.message || "No se pudieron guardar otros involucrados",
            "error",
          );
        },
      });
    };

    guardarConductores();
  }

  cargarDatosRelacionados(): void {
    this.conductoresService.getBySiniestroId(this.siniestroId).subscribe({
      next: (conductores) => {
        console.log("Conductores obtenidos:", conductores); 
        this.conductoresInvolucrados = conductores;
        this.nuevosConductores = [];
      },
      error: () => {
        this.conductoresInvolucrados = [];
      },
    });

    this.vehiculoInvolucradoService
      .getBySiniestroId(this.siniestroId)
      .subscribe({
        next: (vehiculos) => {
          this.vehiculosInvolucrados = vehiculos;
          this.nuevosVehiculos = [];
        },
        error: () => {
          this.vehiculosInvolucrados = [];
        },
      });

    this.otrosInvolucradosService.getBySiniestroId(this.siniestroId).subscribe({
      next: (otros) => {
        this.otrosInvolucrados = otros;
        this.nuevosOtros = [];
      },
      error: () => {
        this.otrosInvolucrados = [];
      },
    });
  }

  abrirModalConductor(content: any, conductor?: any, index?: number): void {
    this.conductorEditandoIndex = typeof index === "number" ? index : null;

    this.formConductorInvolucrado.reset({
      usaba_cinturon: 0,
      mision_laboral: 0,
    });

    if (conductor?.id) {
      this.conductoresService.getConductorById(conductor.id).subscribe({
        next: (detalle) => {
          this.formConductorInvolucrado.patchValue({
            nombre: detalle.nombre ?? "",
            tipodocumento: detalle.tipodocumento,
            n_documento: detalle.n_documento,
            rol_siniestro: detalle.rol_siniestro?.toString(),
            fecha_nacimiento: detalle.fecha_nacimiento
              ? detalle.fecha_nacimiento.substring(0, 10)
              : null,
            estado_momento_siniestro: detalle.estado_momento_siniestro,
            categoria: detalle.categoria,
            n_licencia: detalle.n_licencia,
            fecha_expedicion: detalle.fecha_expedicion
              ? detalle.fecha_expedicion.substring(0, 10)
              : null,
            fecha_vencimiento: detalle.fecha_vencimiento
              ? detalle.fecha_vencimiento.substring(0, 10)
              : null,
            usaba_cinturon: detalle.usaba_cinturon,
            mision_laboral: detalle.mision_laboral,
          });
        },
        error: (err) => {
          console.error("Error al obtener detalle del conductor", err);
        },
      });
    }

    this.modalService.open(content, {
      centered: true,
      size: "lg",
      scrollable: true,
    });
  }

  abrirModalVehiculo(
    content: any,
    vehiculo?: VehiculoInvolucrado,
    index?: number,
  ): void {
    this.vehiculoEditandoIndex = typeof index === "number" ? index : null;
    this.formVehiculoInvolucrado.reset({ carga: 0 });

    if (vehiculo?.id) {
      this.vehiculoInvolucradoService.getVehiculoById(vehiculo.id).subscribe({
        next: (detalle) => {
          this.formVehiculoInvolucrado.patchValue({
            placa_involucrado: detalle.placa ?? "",
            numero_interno: detalle.numero_interno ?? "",
            tipo_vehiculo: detalle.tipo_vehiculo,
            propiedad_vehiculo: detalle.propiedad_vehiculo,
            fecha_vencimiento: detalle.fecha_vencimiento
              ? detalle.fecha_vencimiento.substring(0, 10)
              : null,
            revision_tecnomecanica: detalle.revision_tecnomecanica
              ? detalle.revision_tecnomecanica.substring(0, 10)
              : null,
            carga: detalle.carga ?? 0,
            descripcion_carga: detalle.descripcion_carga ?? "",
            empresa_transportadora: detalle.empresa_transportadora ?? "",
          });
        },
        error: (err) => {
          console.error("Error al obtener detalle del vehículo", err);
        },
      });
    }

    this.modalService.open(content, {
      centered: true,
      size: "lg",
      scrollable: true,
    });
  }

  abrirModalOtro(content: any, otro?: OtrosInvolucrado, index?: number): void {
    this.otroEditandoIndex = typeof index === "number" ? index : null;
    this.formOtrosInvolucrado.reset({ lesiones: 0, danos: 0 });

    if (otro?.id) {
      this.otrosInvolucradosService.getById(otro.id).subscribe({
        next: (detalle) => {
          this.formOtrosInvolucrado.patchValue({
            tipo_actor_vial: detalle.tipo_actor_vial,
            nombre: detalle.nombre ?? "",
            n_documento: detalle.n_documento,
            placa: detalle.placa ?? "",
            lesiones: detalle.lesiones ?? 0,
            danos: detalle.danos ?? 0,
          });
        },
        error: (err) => {
          console.error("Error al obtener detalle del otro involucrado", err);
        },
      });
    }

    this.modalService.open(content, {
      centered: true,
      size: "lg",
      scrollable: true,
    });
  }

  private cerrarEstadoEdicionConductor(): void {
    this.conductorEditandoIndex = null;
    this.formConductorInvolucrado.reset({
      usaba_cinturon: 0,
      mision_laboral: 0,
    });
  }

  private cerrarEstadoEdicionVehiculo(): void {
    this.vehiculoEditandoIndex = null;
    this.formVehiculoInvolucrado.reset({ carga: 0 });
  }

  private cerrarEstadoEdicionOtro(): void {
    this.otroEditandoIndex = null;
    this.formOtrosInvolucrado.reset({ lesiones: 0, danos: 0 });
  }

  private reemplazarConductorEnListas(
    indice: number,
    conductorActualizado: ConductorSiniestro,
  ): void {
    this.conductoresInvolucrados[indice] = conductorActualizado;
    this.nuevosConductores = this.nuevosConductores.map((item) =>
      item.id && conductorActualizado.id
        ? item.id === conductorActualizado.id
          ? conductorActualizado
          : item
        : item.n_documento === conductorActualizado.n_documento
          ? conductorActualizado
          : item,
    );
  }

  private reemplazarVehiculoEnListas(
    indice: number,
    vehiculoActualizado: VehiculoInvolucrado,
  ): void {
    this.vehiculosInvolucrados[indice] = vehiculoActualizado;
    this.nuevosVehiculos = this.nuevosVehiculos.map((item) =>
      item.id && vehiculoActualizado.id
        ? item.id === vehiculoActualizado.id
          ? vehiculoActualizado
          : item
        : item.placa === vehiculoActualizado.placa
          ? vehiculoActualizado
          : item,
    );
  }

  private reemplazarOtroEnListas(
    indice: number,
    otroActualizado: OtrosInvolucrado,
  ): void {
    this.otrosInvolucrados[indice] = otroActualizado;
    this.nuevosOtros = this.nuevosOtros.map((item) =>
      item.id && otroActualizado.id
        ? item.id === otroActualizado.id
          ? otroActualizado
          : item
        : item.n_documento === otroActualizado.n_documento &&
            item.placa === otroActualizado.placa
          ? otroActualizado
          : item,
    );
  }

  private validarCamposRequeridosInvolucrados(): boolean {
    for (const [campo, mensaje] of Object.entries(
      this.mensajesRequeridosInvolucrados,
    )) {
      const control = this.formVehiculoInvolucrado.get(campo);

      if (
        control &&
        (control.value === null ||
          control.value === "" ||
          control.value === undefined)
      ) {
        control.markAsTouched();
        this.mostrarAlerta("Campo requerido", mensaje, "info");
        return false;
      }
    }
    return true;
  }

  buscarConductoresPorPlaca(): void {
    const placa = this.formSiniestro
      .get("placa")
      ?.value?.toString()
      .trim()
      .toUpperCase();

    if (!placa) {
      this.mostrarAlerta(
        "Error",
        "Debes ingresar la placa en Información del vehículo",
        "error",
      );
      return;
    }

    this.formSiniestro.patchValue({ placa });
    this.conductorVehiculoService.getConductoresPorPlaca(placa).subscribe({
      next: (conductores) => {
        this.conductoresPorPlaca = conductores;

        if (!conductores?.length) {
          this.mostrarAlerta(
            "Información",
            "No se encontraron conductores para esa placa",
            "info",
          );
        }
      },
      error: () => {
        this.mostrarAlerta(
          "Error",
          "No se pudieron obtener los conductores",
          "error",
        );
      },
    });
  }

  onConductorSeleccionadoEnModal(conductor: any): void {
    if (conductor?.propietario) {
      const nombreCompleto = [
        conductor.propietario.primernombre,
        conductor.propietario.segundonombre,
        conductor.propietario.papellidos,
        conductor.propietario.seapellidos,
      ]
        .filter((parte) => !!parte)
        .join(" ")
        .trim();

      this.formConductorInvolucrado.patchValue({
        nombre: nombreCompleto,
        tipodocumento: conductor.propietario.tipo,
        n_documento: conductor.conductor_id,
        rol_siniestro: conductor.rol_siniestro ?? null, // 👈 si viene del backend
        fecha_nacimiento: conductor.propietario.fechanace
          ? conductor.propietario.fechanace.substring(0, 10)
          : null,
        fecha_expedicion: conductor.propietario.expediciolic
          ? conductor.propietario.expediciolic.substring(0, 10)
          : null,
        categoria: conductor.propietario.categoria,
        n_licencia: conductor.propietario.numerolic,
        fecha_vencimiento: conductor.propietario.vencelic
          ? conductor.propietario.vencelic.substring(0, 10)
          : null,
        estado_momento_siniestro: conductor.estado_momento_siniestro ?? null,
        usaba_cinturon: conductor.usaba_cinturon ?? 0,
        mision_laboral: conductor.mision_laboral ?? 0,
      });
    }
  }

  private guardarConductorEnBackend(
    conductor: ConductorSiniestro,
    modal: any,
  ): void {
    const conductoresPayload: ConductorSiniestro[] = [
      {
        id_siniestro: this.siniestroId,
        ...conductor,
        nombre: String(conductor.nombre ?? "").trim(),
      },
    ];

    this.conductoresService.createConductor(conductoresPayload).subscribe({
      next: (respuesta) => {
        const guardados = respuesta?.length ? respuesta : conductoresPayload;
        this.conductoresInvolucrados.push(...guardados);
        this.formConductorInvolucrado.reset();
        Swal.fire(
          "Conductor agregado",
          "El conductor fue guardado correctamente",
          "success",
        );
        modal.close();
      },
      error: (err) => {
        Swal.fire(
          "Error",
          err.error?.message || "No se pudo guardar el conductor",
          "error",
        );
      },
    });
  }

  agregarConductor(): boolean {
    if (this.formConductorInvolucrado.invalid) {
      this.formConductorInvolucrado.markAllAsTouched();
      Swal.fire(
        "Campos incompletos",
        "Debe llenar todos los datos obligatorios del conductor",
        "warning",
      );
      return false;
    }

    const conductor = this.formConductorInvolucrado.getRawValue();
    const existe = this.conductoresInvolucrados.some(
      (item) => item.n_documento === conductor.n_documento,
    );

    if (existe) {
      Swal.fire(
        "Conductor duplicado",
        "Ya existe un conductor con ese documento en el listado",
        "warning",
      );
      return false;
    }

    const conductorParaGuardar: ConductorSiniestro = {
      id_siniestro: this.siniestroId,
      ...conductor,
      nombre: conductor.nombre?.trim(),
    };

    this.conductoresInvolucrados.push(conductorParaGuardar);
    this.formConductorInvolucrado.reset();
    Swal.fire(
      "Conductor agregado",
      "El conductor fue agregado correctamente",
      "success",
    );
    return true;
  }

  guardarConductorDesdeModal(modal: any): void {
    if (this.formConductorInvolucrado.invalid) {
      this.formConductorInvolucrado.markAllAsTouched();
      Swal.fire(
        "Campos incompletos",
        "Debe llenar todos los datos obligatorios del conductor",
        "warning",
      );
      return;
    }

    const conductor = this.formConductorInvolucrado.getRawValue();
    const existe = this.conductoresInvolucrados.some(
      (item) => item.n_documento === conductor.n_documento,
    );

    if (this.conductorEditandoIndex === null && existe) {
      Swal.fire(
        "Conductor duplicado",
        "Ya existe un conductor con ese documento en el listado",
        "warning",
      );
      return;
    }

    const conductorParaGuardar: ConductorSiniestro = {
      id_siniestro: this.siniestroId,
      ...conductor,
      nombre: String(conductor.nombre ?? "").trim(),
    };

    if (this.conductorEditandoIndex !== null) {
      const conductorExistente =
        this.conductoresInvolucrados[this.conductorEditandoIndex];

      if (conductorExistente?.id) {
        this.conductoresService
          .updateConductor(conductorExistente.id, {
            ...conductorExistente,
            ...conductorParaGuardar,
            id: conductorExistente.id,
          })
          .subscribe({
            next: (respuesta) => {
              const actualizado = {
                ...conductorExistente,
                ...conductorParaGuardar,
                ...respuesta,
                id: conductorExistente.id,
              };

              this.reemplazarConductorEnListas(
                this.conductorEditandoIndex as number,
                actualizado,
              );
              this.cerrarEstadoEdicionConductor();
              Swal.fire(
                "Conductor actualizado",
                "El registro fue actualizado correctamente",
                "success",
              );
              modal.close();
            },
            error: (err) => {
              Swal.fire(
                "Error",
                err.error?.message || "No se pudo actualizar el conductor",
                "error",
              );
            },
          });
        return;
      }

      this.reemplazarConductorEnListas(
        this.conductorEditandoIndex,
        conductorParaGuardar,
      );
      this.cerrarEstadoEdicionConductor();
      Swal.fire(
        "Conductor actualizado",
        "El registro fue actualizado correctamente",
        "success",
      );
      modal.close();
      return;
    }

    this.guardarConductorEnBackend(conductor, modal);
  }

  agregarVehiculo(): boolean {
    if (!this.validarCamposRequeridosInvolucrados()) {
      return false;
    }

    if (this.formVehiculoInvolucrado.invalid) {
      this.formVehiculoInvolucrado.markAllAsTouched();
      Swal.fire(
        "Campos incompletos",
        "Debe llenar todos los datos obligatorios del vehículo",
        "warning",
      );
      return false;
    }

    const vehiculo = this.formVehiculoInvolucrado.getRawValue();
    const vehiculoParaGuardar: VehiculoInvolucrado = {
      ...vehiculo,
      placa: vehiculo.placa_involucrado?.trim().toUpperCase(),
      numero_interno: vehiculo.numero_interno?.trim(),
      empresa_transportadora: vehiculo.empresa_transportadora?.trim(),
    };

    delete (vehiculoParaGuardar as any).placa_involucrado;

    const existe = this.vehiculosInvolucrados.some(
      (item) => item.placa === vehiculoParaGuardar.placa,
    );

    if (existe) {
      Swal.fire(
        "Vehículo duplicado",
        "Ya existe un vehículo con esa placa en el listado",
        "warning",
      );
      return false;
    }

    this.vehiculosInvolucrados.push(vehiculoParaGuardar);
    this.nuevosVehiculos.push(vehiculoParaGuardar);
    this.formVehiculoInvolucrado.reset({ carga: 0 });
    Swal.fire(
      "Vehículo agregado",
      "El vehículo fue agregado correctamente",
      "success",
    );
    return true;
  }

  guardarVehiculoDesdeModal(modal: any): void {
    if (this.formVehiculoInvolucrado.invalid) {
      this.formVehiculoInvolucrado.markAllAsTouched();
      Swal.fire(
        "Campos incompletos",
        "Debe llenar todos los datos obligatorios del vehículo",
        "warning",
      );
      return;
    }

    const vehiculo = this.formVehiculoInvolucrado.getRawValue();
    const vehiculoParaGuardar: VehiculoInvolucrado = {
      ...vehiculo,
      placa: vehiculo.placa_involucrado?.trim().toUpperCase(),
      numero_interno: vehiculo.numero_interno?.trim(),
      empresa_transportadora: vehiculo.empresa_transportadora?.trim(),
    };

    delete (vehiculoParaGuardar as any).placa_involucrado;

    const existe = this.vehiculosInvolucrados.some(
      (item) => item.placa === vehiculoParaGuardar.placa,
    );

    if (this.vehiculoEditandoIndex === null && existe) {
      Swal.fire(
        "Vehículo duplicado",
        "Ya existe un vehículo con esa placa en el listado",
        "warning",
      );
      return;
    }

    if (this.vehiculoEditandoIndex !== null) {
      const vehiculoExistente =
        this.vehiculosInvolucrados[this.vehiculoEditandoIndex];

      if (vehiculoExistente?.id) {
        this.vehiculoInvolucradoService
          .updateVehiculo(vehiculoExistente.id, {
            ...vehiculoExistente,
            ...vehiculoParaGuardar,
            id: vehiculoExistente.id,
          })
          .subscribe({
            next: (respuesta) => {
              const actualizado = {
                ...vehiculoExistente,
                ...vehiculoParaGuardar,
                ...respuesta,
                id: vehiculoExistente.id,
              };

              this.reemplazarVehiculoEnListas(
                this.vehiculoEditandoIndex as number,
                actualizado,
              );
              this.cerrarEstadoEdicionVehiculo();
              Swal.fire(
                "Vehículo actualizado",
                "El registro fue actualizado correctamente",
                "success",
              );
              modal.close();
            },
            error: (err) => {
              Swal.fire(
                "Error",
                err.error?.message || "No se pudo actualizar el vehículo",
                "error",
              );
            },
          });
        return;
      }

      this.reemplazarVehiculoEnListas(
        this.vehiculoEditandoIndex,
        vehiculoParaGuardar,
      );
      this.cerrarEstadoEdicionVehiculo();
      Swal.fire(
        "Vehículo actualizado",
        "El registro fue actualizado correctamente",
        "success",
      );
      modal.close();
      return;
    }

    this.vehiculosInvolucrados.push(vehiculoParaGuardar);
    this.nuevosVehiculos.push(vehiculoParaGuardar);
    this.formVehiculoInvolucrado.reset({ carga: 0 });
    Swal.fire(
      "Vehículo agregado",
      "El vehículo fue agregado correctamente",
      "success",
    );
    modal.close();
  }

  guardarOtroDesdeModal(modal: any): void {
    if (this.formOtrosInvolucrado.invalid) {
      this.formOtrosInvolucrado.markAllAsTouched();
      Swal.fire(
        "Campos incompletos",
        "Debe llenar todos los datos obligatorios del otro involucrado",
        "warning",
      );
      return;
    }

    const otro = this.formOtrosInvolucrado.getRawValue();
    const otroParaGuardar: OtrosInvolucrado = {
      id_siniestro: this.siniestroId,
      tipo_actor_vial: otro.tipo_actor_vial,
      nombre: otro.nombre?.trim(),
      n_documento: otro.n_documento,
      placa: otro.placa?.trim().toUpperCase(),
      lesiones: otro.lesiones,
      danos: otro.danos,
      estado: otro.estado ?? 1,
    };

    const existe = this.otrosInvolucrados.some(
      (item) =>
        item.n_documento === otroParaGuardar.n_documento &&
        item.placa === otroParaGuardar.placa,
    );

    if (this.otroEditandoIndex === null && existe) {
      Swal.fire(
        "Otro involucrado duplicado",
        "Ya existe un registro con ese documento y placa",
        "warning",
      );
      return;
    }

    if (this.otroEditandoIndex !== null) {
      const otroExistente = this.otrosInvolucrados[this.otroEditandoIndex];

      if (otroExistente?.id) {
        this.otrosInvolucradosService
          .update(otroExistente.id, {
            ...otroExistente,
            ...otroParaGuardar,
            id: otroExistente.id,
          })
          .subscribe({
            next: (respuesta) => {
              const actualizado = {
                ...otroExistente,
                ...otroParaGuardar,
                ...respuesta,
                id: otroExistente.id,
              };

              this.reemplazarOtroEnListas(
                this.otroEditandoIndex as number,
                actualizado,
              );
              this.cerrarEstadoEdicionOtro();
              Swal.fire(
                "Otro involucrado actualizado",
                "El registro fue actualizado correctamente",
                "success",
              );
              modal.close();
            },
            error: (err) => {
              Swal.fire(
                "Error",
                err.error?.message ||
                  "No se pudo actualizar el otro involucrado",
                "error",
              );
            },
          });
        return;
      }

      this.reemplazarOtroEnListas(this.otroEditandoIndex, otroParaGuardar);
      this.cerrarEstadoEdicionOtro();
      Swal.fire(
        "Otro involucrado actualizado",
        "El registro fue actualizado correctamente",
        "success",
      );
      modal.close();
      return;
    }

    this.otrosInvolucradosService.create([otroParaGuardar]).subscribe({
      next: (respuesta) => {
        const guardados = respuesta?.length ? respuesta : [otroParaGuardar];
        this.otrosInvolucrados.push(...guardados);
        this.formOtrosInvolucrado.reset({ lesiones: 0, danos: 0 });
        Swal.fire(
          "Otro involucrado agregado",
          "El registro fue guardado correctamente",
          "success",
        );
        modal.close();
      },
      error: (err) => {
        Swal.fire(
          "Error",
          err.error?.message || "No se pudo guardar el otro involucrado",
          "error",
        );
      },
    });
  }

  eliminarConductor(index: number): void {
    const conductor = this.conductoresInvolucrados[index];
    if (conductor?.id) {
      this.conductoresService.deleteConductor(conductor.id).subscribe({
        next: () => {
          this.conductoresInvolucrados.splice(index, 1);
          this.nuevosConductores = this.nuevosConductores.filter(
            (item) => item.n_documento !== conductor.n_documento,
          );
          Swal.fire("Eliminado", "Conductor eliminado del listado", "success");
        },
        error: () => {
          Swal.fire("Error", "No se pudo eliminar el conductor", "error");
        },
      });
      return;
    }

    this.conductoresInvolucrados.splice(index, 1);
    this.nuevosConductores = this.nuevosConductores.filter(
      (item) => item.n_documento !== conductor?.n_documento,
    );
    Swal.fire("Eliminado", "Conductor eliminado del listado", "success");
  }

  eliminarVehiculo(index: number): void {
    const vehiculo = this.vehiculosInvolucrados[index];
    if (vehiculo?.id) {
      this.vehiculoInvolucradoService.deleteVehiculo(vehiculo.id).subscribe({
        next: () => {
          this.vehiculosInvolucrados.splice(index, 1);
          this.nuevosVehiculos = this.nuevosVehiculos.filter(
            (item) => item.placa !== vehiculo.placa,
          );
          Swal.fire("Eliminado", "Vehículo eliminado del listado", "success");
        },
        error: () => {
          Swal.fire("Error", "No se pudo eliminar el vehículo", "error");
        },
      });
      return;
    }

    this.vehiculosInvolucrados.splice(index, 1);
    this.nuevosVehiculos = this.nuevosVehiculos.filter(
      (item) => item.placa !== vehiculo?.placa,
    );
    Swal.fire("Eliminado", "Vehículo eliminado del listado", "success");
  }

  eliminarOtroInvolucrado(index: number): void {
    const otro = this.otrosInvolucrados[index];
    if (otro?.id) {
      this.otrosInvolucradosService.delete(otro.id).subscribe({
        next: () => {
          this.otrosInvolucrados.splice(index, 1);
          this.nuevosOtros = this.nuevosOtros.filter(
            (item) =>
              item.n_documento !== otro.n_documento ||
              item.placa !== otro.placa,
          );
          Swal.fire("Eliminado", "Registro eliminado del listado", "success");
        },
        error: () => {
          Swal.fire("Error", "No se pudo eliminar el registro", "error");
        },
      });
      return;
    }

    this.otrosInvolucrados.splice(index, 1);
    this.nuevosOtros = this.nuevosOtros.filter(
      (item) =>
        item.n_documento !== otro?.n_documento || item.placa !== otro?.placa,
    );
    Swal.fire("Eliminado", "Registro eliminado del listado", "success");
  }

  getNombreTipoVehiculo(id: any): string {
    const tipo = this.tiposVehiculo.find((item) => item.idTipos == id);
    return tipo ? tipo.tipos : "";
  }

  getNombrePropiedadVehiculo(id: any): string {
    const propiedad = this.propiedadesVehiculo.find((item) => item.id == id);
    return propiedad ? propiedad.relacion : "";
  }

  cargarTipoSiniestro(): void {
    this.tipoSiniestroService.getAllTipoSiniestroActivos().subscribe({
      next: (tipos) => (this.tiposSiniestro = tipos),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los tipos de siniestro",
          "error",
        ),
    });
  }

  cargarNivelesSeveridad(): void {
    this.nivelSeveridadService.getAllNivelSeveridadActivos().subscribe({
      next: (niveles) => (this.nivelesSeveridad = niveles),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los niveles de severidad",
          "error",
        ),
    });
  }

  cargarTiposVia(): void {
    this.tipoviaService.getAllTipoViaActivos().subscribe({
      next: (tipos) => (this.vias = tipos),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los tipos de vía",
          "error",
        ),
    });
  }

  cargarMarcasVehiculo(): void {
    this.marcaService.getMarcas().subscribe({
      next: (marcas) => {
        this.marcasVehiculo = marcas;
        this.normalizarMarcaYModelo();
      },
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar las marcas de vehículo",
          "error",
        ),
    });
  }

  cargarModelosVehiculo(): void {
    this.modelosService.getModelos().subscribe({
      next: (modelos) => {
        this.modelosVehiculo = modelos;
        this.normalizarMarcaYModelo();
      },
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los modelos de vehículo",
          "error",
        ),
    });
  }

  private normalizarMarcaYModelo(): void {
    const marcaActual = this.formSiniestro.get("marca")?.value;
    const modeloActual = this.formSiniestro.get("modelo")?.value;

    const marcaNumerica = Number(marcaActual);
    const modeloNumerico = Number(modeloActual);

    const marcaId = this.marcasVehiculo.find(
      (marca) => marca?.id === marcaNumerica || marca?.marca === marcaActual,
    )?.id;

    const modeloId = this.modelosVehiculo.find(
      (modelo) =>
        modelo?.id === modeloNumerico || modelo?.modelo === modeloActual,
    )?.id;

    const valorMarca = Number.isNaN(marcaNumerica) ? marcaId : marcaNumerica;
    const valorModelo = Number.isNaN(modeloNumerico)
      ? modeloId
      : modeloNumerico;

    if (valorMarca !== undefined && valorMarca !== null) {
      this.formSiniestro.patchValue({ marca: valorMarca });
    }

    if (valorModelo !== undefined && valorModelo !== null) {
      this.formSiniestro.patchValue({ modelo: valorModelo });
    }
  }

  getDatos(): void {
    this.dataService.getDatos().subscribe({
      next: (datos) => {
        this.municipios = datos;
        this.departamentos = Array.from(
          new Map(
            datos.map((m) => [
              m.departamento.id_departamento,
              {
                id: m.departamento.id_departamento,
                nombre: m.departamento.nombre,
              },
            ]),
          ).values(),
        );
      },
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los municipios",
          "error",
        ),
    });
  }

  cargarCondicionesClimaticas(): void {
    this.condicionesClimaticasService
      .getAllCondicionesClimaticasActivas()
      .subscribe({
        next: (condiciones) => (this.condicionesClimaticas = condiciones),
        error: () =>
          this.mostrarAlerta(
            "Error",
            "No se pudieron cargar las condiciones climáticas",
            "error",
          ),
      });
  }

  cargarTiposVehiculo(): void {
    this.tiposService.getTipos().subscribe({
      next: (tipos) => (this.tiposVehiculo = tipos),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los tipos de vehículo",
          "error",
        ),
    });
  }

  cargarEstadoConductor(): void {
    this.estadoConductorService.getEstados().subscribe({
      next: (estados) => (this.estadosConductor = estados),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los estados del conductor",
          "error",
        ),
    });
  }

  cargarRelaciones(): void {
    this.relacionService.getRelaciones().subscribe({
      next: (relaciones) => (this.propiedadesVehiculo = relaciones),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar las propiedades del vehículo",
          "error",
        ),
    });
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any): void {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }

  onMunicipioChange(municipioSeleccionado: any): void {
    if (municipioSeleccionado?.departamento) {
      this.formSiniestro.patchValue({
        departamento: municipioSeleccionado.departamento.id_departamento,
      });
    }
  }

  updateMap(): void {
    const lat = this.formSiniestro.get("coordenadas_latitud")?.value;
    const lng = this.formSiniestro.get("coordenadas_longitud")?.value;

    const latNum = Number(lat);
    const lngNum = Number(lng);

    if (!isNaN(latNum) && !isNaN(lngNum)) {
      this.mapUrl = `https://www.google.com/maps?q=${latNum},${lngNum}&output=embed`;
    } else {
      this.mapUrl = "";
    }
  }

  buscarVehiculoPorPlaca(): void {
    let placa = this.formSiniestro.get("placa")?.value;
    if (!placa) {
      this.mostrarAlerta("Error", "Debes ingresar una placa", "error");
      return;
    }

    placa = placa.toUpperCase();
    this.formSiniestro.patchValue({ placa });

    this.VehiculosService.getPlacasBySiniestro(placa).subscribe({
      next: (vehiculo) => {
        // autocompletar campos del formulario con los datos recibidos
        const marcaId = this.marcasVehiculo.find(
          (marca) =>
            marca?.id === vehiculo.marca || marca?.marca === vehiculo.marca,
        )?.id;
        const modeloId = this.modelosVehiculo.find(
          (modelo) =>
            modelo?.id === vehiculo.modelo ||
            modelo?.modelo === vehiculo.modelo,
        )?.id;

        this.formSiniestro.patchValue({
          tipo_vehiculo: vehiculo.clase, // si tu backend devuelve id
          marca: marcaId ?? vehiculo.marca,
          linea: vehiculo.linea,
          modelo: modeloId ?? vehiculo.modelo,
          propiedad_vehiculo: vehiculo.relacion,
        });
      },
      error: () => {
        this.mostrarAlerta(
          "Error",
          "No se encontró vehículo con esa placa",
          "error",
        );
      },
    });
  }

  getRolLabel(value: number | string): string {
    const rol = this.rolesSiniestro.find((r) => r.value == value);
    return rol ? rol.label : "";
  }

  cargarDocumentosSiniestro(): void {
    //console.log("ENTRÓ A cargarDocumentosSiniestro");
    const placa = this.formSiniestro.get("placa")?.value?.toUpperCase();
    const carpeta = `${this.administraciones[0].nit}/pesv/siniestro/${placa}/${this.siniestroId}`;
    //console.log("Nit:", this.administraciones);
    //console.log("Placa:", this.formSiniestro.get("placa")?.value);
    //console.log("Id:", this.siniestroId);
    //console.log(carpeta);
    this.digitalesService.getDocumentosSiniestro(carpeta).subscribe({
      next: (resp) => {
        this.documentosGuardados = resp.archivos; // lista completa
      },
      error: (err) => {
        console.error("Error al cargar documentos:", err);
      },
    });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0] as File;
    if (!file) return;

    this.archivosSeleccionados.push(file);

    if (file.type.startsWith("image")) {
      const reader = new FileReader();
      reader.onload = () => this.previews.push(reader.result);
      reader.readAsDataURL(file);
    } else {
      this.previews.push(null);
    }

    event.target.value = "";
  }

  private cargarDataAdmin(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
        this.administraciones = data;

        this.adminCargada = true;
        this.intentarCargarDocumentos();
      },
    });
  }

  eliminarDocumento(index: number) {
    this.archivosSeleccionados.splice(index, 1);
    this.previews.splice(index, 1);
  }

  subirDocumentos(idSiniestro: number): void {
    const placa = this.formSiniestro.get("placa")?.value?.toUpperCase();
    const carpeta = `${this.administraciones[0].nit}/pesv/siniestro/${placa}/${idSiniestro}`;

    this.archivosSeleccionados.forEach((archivo, index) => {
      const nombreArchivo = `${idSiniestro}_${index + 1}`;
      this.digitalesService
        .subirDocumentoSiniestro(
          archivo,
          idSiniestro,
          carpeta,
          index,
          "soporte",
        )
        .subscribe({
          next: () =>
            console.log(`Documento ${index + 1} cargado correctamente`),
          error: (err) =>
            console.error(`Error al subir documento ${index + 1}:`, err),
        });
    });
  }

  private intentarCargarDocumentos(): void {
    if (this.adminCargada && this.siniestroCargado) {
      this.cargarDocumentosSiniestro();
    }
  }
}
